import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { UserserviceService } from '../userservice.service';
import { HttpClient , HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';
import { ReCaptcha2Component } from 'ngx-captcha';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public formControl = new FormControl();
   Loginform!: FormGroup;

   @ViewChild('captchaElem')
  captchaElem!: ReCaptcha2Component ;
  @ViewChild('langInput')
  langInput!: ElementRef;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;
  
  loginuser: any;
  // username: any;
  role: any;
  // siteKey: string="6LeCIYseAAAAAIvHzxeyoDYs8BJa-xEjVhxKa-yM";
 // siteKey: string="6LfyorAeAAAAAG8BJ3HrLP-HPHNWWO45JzKJd4nN";
  siteKey: string="6Lfp7uYkAAAAACIGySKyhivHiPkHw3myco8BFBn8";
  //Requestform: any;
  loading = false;
  submitted = false;
  loginusername!:any;
  loginuserpass!:any;
  loginfail:boolean=false;
  typetext1!:boolean;
  loggeduser="";
  proccessing: boolean=false;

  constructor(private service:UserserviceService ,public router: Router,private httpClient: HttpClient,private route: ActivatedRoute,private formBuilder: FormBuilder) {
     
    this.Loginform = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      recaptcha: ['', Validators.required]
      });}
  ngOnInit(): void { 
    if(!sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")==null){
      this.router.navigate(['/Login']);
    }
    else{
      this.router.navigate(['/dashboard']);
    }
    
    }
  
  get f() { return this.Loginform.controls; }


 
  onSubmit(form:any){

    this.submitted = true;
    if (this.Loginform.invalid) {
      return;
   }
    
    this.loginusername=this.Loginform.value.username;
    this.loginuserpass=this.Loginform.value.password;
   this.login();
    
    }
    // console.log(loginuserdetail);
   
  
   
  resetF(){
    this.submitted=false;
    // this.Requestform.recaptcha.reset();
  }
  show_hide_password1(){
    this.typetext1 =!this.typetext1;
  }
  hidewarningmsg(){
    this.loginfail=false;
  }
  login(){
  this.proccessing=true; 
  let logindetail :{email_address:any, password:any}={
      email_address:this.loginusername,
      password:this.loginuserpass
  };
  this.service.post('/Student_module/logincheck',logindetail).subscribe((res:any)=>{
  //  console.log(res);
   if(res.status=="success"){
     if(res.Data[0].role_id=="1"){
        sessionStorage.setItem('loggeduser',res.Data[0].username);
        sessionStorage.setItem('loggeduserid',res.Data[0].user_id);
        sessionStorage.setItem('roleid',res.Data[0].role_id);

        this.getapptype();       
     }
     else{
       alert("This portal is for student use");
       window.location.reload();
       this.proccessing=false
     }
  
   }
   else{
     alert(res.Data);
     this.Loginform.reset();
     this.submitted=false;
     this.proccessing=false;
   }
 });
  }
  getapptype(){  
    let getstud:{ user_id:any,email_address:any}={
      user_id: sessionStorage.getItem('loggeduserid'),
      email_address: sessionStorage.getItem('loggeduser')
    };
      this.service.post('/Student_module/getregistration',getstud).subscribe((res:any)=>{
        if(res.status=="success"){
          setTimeout(()=>{
            this.proccessing=false;
            sessionStorage.setItem('loggedapptype',res.Data[0].application_type);
            const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
                     this.router.navigateByUrl(returnUrl).then(() => {
                       window.location.reload();
                      });
          },1000); 
        }
        else{
          alert("Sorry!!\nPage you requested is not able to load, Please retry!")
          this.router.navigate(['/Login']);
          this.proccessing=false;
        }
          
      });
  }

 
  displayStyle = "none";
  openPopup() {
    this.displayStyle = "block";
  }
  closePopup() {
    this.displayStyle = "none";
  }
  gotoresetpassword(){
    this.router.navigate(['/resetpassword','student'], {
      skipLocationChange: true,
    });
  }
}